<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h4>Education</h4>
      <vs-tooltip text="Add" color="primary">
        <vs-button
          type="border"
          color="primary"
          icon="add"
          @click="handleAddPopUp"
        />
      </vs-tooltip>
    </div>
    <div class="table-responsive">
      <table v-if="educationProps.length > 0" class="light_blue_table w-full">
        <tbody>
          <tr :key="indextr" v-for="(item, indextr) in educationProps">
            <td>
              <div v-if="item.certificate_picture">
                <div v-if="item.certificate_picture.includes('.pdf')">
                  <img
                  style="width: 40px; height: 40px"
                  src="@/assets/images/file-icons/pdf.png"
                />
                </div>
                <img
                  v-else
                  style="width: 40px; height: 40px"
                  :src="item.certificate_picture"
                />
              </div>
              <img
                v-else
                style="width: 40px; height: 40px"
                src="@/assets/images/placeholder.png"
              />
            </td>
            <td>
              {{ item.institute }}
            </td>

            <td>
              {{ item.degree }}
            </td>
            <td>
              {{ item.start_from | moment("MMM-YYYY") }}
            </td>
            <td>
              <span v-if="item.still_studying === 0">
                {{ item.end_to | moment("MMM-YYYY") }}
              </span>
            </td>
            <td class="text-right">
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-if="item.certificate_picture">
                    <a
                      v-if="item.certificate_picture"
                      :href="item.certificate_picture"
                      target="_blank"
                      >Preview
                    </a> </vs-dropdown-item
                  ><vs-dropdown-item @click="handleedit(indextr)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="remove(indextr)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="educationProps.length == 0" class="text-center">
        No Education found
      </div>
    </div>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Add Education"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="institute"
              v-model="education.institute"
              class="custom_Input"
              label="Institution Name"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.institute')" class="text-danger">{{
              errors.first("add.institute")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="degree"
              v-model="education.degree"
              class="custom_Input"
              label="Degree"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.degree')" class="text-danger">{{
              errors.first("add.degree")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <span style="font-size: 11px"> Still Studying</span>
            <v-select
              v-validate="'required'"
              :options="option"
              label="label"
              name="still-studying"
              :reduce="(option) => option.value"
              v-model="education.still_studying"
            />
            <span v-show="errors.has('still-studying')" class="text-danger">{{
              errors.first("still-studying")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
            <span style="font-size: 11px">From</span>
            <datepicker
              v-validate="'required'"
              name="from"
              :minimumView="'month'"
              :maximumView="'year'"
              :disabled-dates="disabledDates"
              format="MM-yyyy"
              v-model="education.start_from"
              class="w-full edu_from_datepicker"
            />
            <span v-show="errors.has('add.from')" class="text-danger">{{
              errors.first("add.from")
            }}</span>
          </vs-col>
          <vs-col
            v-if="education.still_studying === 0"
            :vs-xs="12"
            :vs-md="6"
            :vs-lg="6"
            class="p-2"
          >
            <span style="font-size: 11px">To</span>
            <datepicker
              v-validate="'required'"
              name="to"
              value="date"
              :minimumView="'month'"
              :maximumView="'year'"
              :disabled-dates="disabledDates1"
              format="MM-yyyy"
              v-model="education.end_to"
              class="w-full"
            />
            <span v-show="errors.has('add.to')" class="text-danger">{{
              errors.first("add.to")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx">
            <label class="block mb-4" for="myfile">Upload a certificate:</label>
            <div>
              <FileUpload
                :platform_module_id="2"
                @changingImage="saveImage"
              ></FileUpload>
            </div>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Education"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="institute"
              v-model="edit.institute"
              class="custom_Input"
              label="Institution Name"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.institute')" class="text-danger">{{
              errors.first("edit.institute")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-model="edit.degree"
              v-validate="'required'"
              name="degree"
              class="custom_Input"
              label="Degree"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.degree')" class="text-danger">{{
              errors.first("edit.degree")
            }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <span style="font-size: 11px"> Still Studying</span>
            <v-select
              :options="option"
              v-validate="'required'"
              name="still-Studying"
              label="label"
              :reduce="(option) => option.value"
              v-model="edit.still_studying"
            />
            <span
              v-show="errors.has('edit.still-Studying')"
              class="text-danger"
              >{{ errors.first("edit.still-Studying") }}</span
            >
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
            <span style="font-size: 11px">From</span>
            <datepicker
              :minimumView="'month'"
              v-validate="'required'"
              name="from"
              :maximumView="'year'"
              v-model="edit.start_from"
              format="MM-yyyy"
              class="w-full"
            />
            <span v-show="errors.has('edit.from')" class="text-danger">{{
              errors.first("edit.from")
            }}</span>
          </vs-col>
          <vs-col
            v-if="edit.still_studying === 0"
            :vs-xs="12"
            :vs-md="6"
            :vs-lg="6"
            class="p-2"
          >
            <span style="font-size: 11px">To</span>
            <datepicker
              :minimumView="'month'"
              v-validate="'required'"
              name="to"
              :maximumView="'year'"
              v-model="edit.end_to"
              format="MM-yyyy"
              class="w-full"
            />
            <span v-show="errors.has('edit.to')" class="text-danger">{{
              errors.first("edit.to")
            }}</span>
          </vs-col>
        
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx">
            <label class="block mb-4" for="myfile">Upload a certificate:</label>
            <div>
              <FileUpload
                :platform_module_id="2"
                @changingImage="saveImageedit"
                :image="edit.certificate_picture"
              ></FileUpload>
            </div>
          </vs-col>
          
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import FileUpload from '@/views/pages/v1/user_profile/components/profile/personal_information/certificateFile.vue'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  components: {
    Datepicker,
    vSelect,
    FileUpload
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    educationProps: {
      required: true,
      type: Array,
      default: () => []
    },
    teacherPersonalDetails: {
      required: false,
      type: Object,
      default: () => {}
    },
    educationAvailability: []
  },
  watch: {
    educationProps: {
      deep: true,
      immediate: true,
      handler () {
        this.educationAvailability = this._.cloneDeep(this.educationProps)
      }
    },
    education: {
      deep: true,
      immediate: true,
      handler () {
        if (this.education.start_from) {
          this.disabledDates1 = {
            to: this.education.start_from
          }
        }
      }
    }
  },
  data () {
    return {
      disabledDates: null,
      disabledDates1: null,
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      education: {
        certificate_picture: null,
        degree: null,
        institute: null,
        still_studying: 1,
        start_from: null,
        end_to: null
      },
      edit: {
        certificate_picture: null,
        degree: null,
        institute: null,
        still_studying: null,
        start_from: null,
        end_to: null
      },
      editIndex: null,
      deleteindex: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      imageDataUrl: null,
      option: [
        {
          label: 'Yes',
          value: 1
        },
        {
          label: 'No',
          value: 0
        }
      ],
      fileName: ''
    }
  },
  mounted () {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()

    this.disabledDates = {
      from: new Date(year, month)
    }
  },
  methods: {
    handleAddPopUp () {
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addpopup = true
    },
    saveImage (url) {
      console.log(url)
      this.education.certificate_picture = url
    },
    saveImageedit (url) {
      this.edit.certificate_picture = url
    },
    handlePhonedefault (index) {
      this.educationAvailability.map((item) => {
        item.default = 0
      })
      this.educationAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const __temp = this.education
          __temp.start_from = this.formatDate(__temp.start_from)
          __temp.end_to =
            this.education.still_studying === 0
              ? this.formatDate(__temp.end_to)
              : null
          __temp.certificate_picture = this.education.certificate_picture
          this.educationAvailability.push(__temp)
          this.educationProps = this.educationAvailability
          this.handleEducationsave()
        }
      })
    },
    async handleEducationsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            educations: this.educationAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        console.log(data.data.operationalUser)
        this.addpopup = false
        this.editpopup = false

        this.education = {
          certificate_picture: null,
          degree: null,
          institute: null,
          still_studying: 1,
          start_from: null,
          end_to: null
        }

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    handleedit (index) {
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editpopup = true
      const temp = this.educationAvailability[index]
      this.edit.year_from = `${temp.month_from}-${temp.year_from}`
      this.edit.year_to = `${temp.month_to}-${temp.year_to}`
      this.edit = temp
      this.editIndex = index
    },
    handleUpdate () {
      //
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          const payload = this.edit
          this.educationAvailability[this.editIndex] = payload
          this.educationProps = this.educationAvailability
          this.handleEducationsave()
        }
      })
    },
    handleDelete () {
      this.handleEducationsave()

      this.educationAvailability.splice(this.deleteindex, 1)
      this.deletepopup = false
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    uploadImg (e, num) {
      const file = e.target.files[0]
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      const fileSize = e.target.files[0].size / 1024 / 1024
      if (fileSize < 5) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = new Blob([e.target.result])
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        //
      } else {
        this.option.img = ''

        this.dialogVisible = false
        this.$vs.notify({
          title: 'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
    },

    formatDate (date) {
      const d = new Date(date)
      let month = `${d.getMonth() + 1}`
      let day = `${d.getDate()}`
      const year = `${d.getFullYear()}`
      if (month.length < 9) {
        month = `0${month}`
      }
      if (day.length < 2) {
        day = `0${day}`
      }
      return [year, month, day].join('-')
    }
  }
}
</script>
  